import { t } from '@transifex/native';

import * as flashActions from 'pkg/actions/flashes';

import * as endpoints from 'pkg/api/endpoints/auto';
import type * as models from 'pkg/api/models';
import { create } from 'pkg/api/models/actions';
import * as sdk from 'pkg/core/sdk';
import { crash } from 'pkg/errors/errors';

interface RelationProps {
	userIds: number[];
	productId: number;
	validUntil: number;
}
export const createRelation = async (
	organizationId: number,
	payload: RelationProps
) => {
	const [request] = await create<
		RelationProps,
		models.userProduct.UserProduct
	>(endpoints.UserProducts.Create(organizationId), payload);

	if (!request.ok) {
		flashActions.show({
			title: crash().title,
		});

		return;
	}

	flashActions.show({
		title: t(`Successfully assigned product`),
	});
};

export const removeRelation = async (
	organizationId: number,
	id: number
): Promise<void> => {
	const request = await sdk.destroy(
		endpoints.UserProducts.Delete(organizationId, id)
	);

	if (!request.ok) {
		flashActions.show({
			title: crash().title,
		});

		return;
	}

	flashActions.show({
		title: t(`Successfully removed assigned product.`),
	});
};

export const updateRelation = async (
	organizationId: number,
	id: number,
	validUntil: number
): Promise<void> => {
	const request = await sdk.patch(
		endpoints.UserProducts.Update(organizationId, id),
		{},
		{ validUntil }
	);

	if (!request.ok) {
		flashActions.show({
			title: crash().title,
		});

		return;
	}

	flashActions.show({
		title: t(`Successfully updated assigned product`),
	});
};
